import React from 'react'
import PropTypes from 'prop-types'
import config from 'config'

import SimpleCta from 'components/simple-cta'
import WidgetPage from 'components/hocs/widget-page'

const variations = {
  'compare-refi-rates': 'Compare Refi Rates',
  'refinance-my-student-loans': 'Refinance My Student Loans',
  'learn-about-student-loan-refi': 'Learn About Student Loan Refi',
  'learn-about-refinancing-loans': 'Learn About Refinancing Loans',
  'compare-rates': 'Compare Rates',
  'find-my-rate': 'Find My Rate',
  'learn-more': 'Learn More',
}
export const SimpleCtaApp = (props) => {
  const { variation, verticals } = props

  const url =
    verticals === 'student-loan-refi'
      ? `${config.credibleRoot}/refinance-student-loans`
      : `${config.credibleRoot}/mortgage/rates/landing`

  return (
    <SimpleCta
      url={url}
      variations={variations}
      large={variations[variation]?.lenght > 20}
      {...props}
    />
  )
}

SimpleCtaApp.propTypes = {
  variation: PropTypes.string.isRequired,
  verticals: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
}

export { SimpleCtaApp as SimpleCtaAppNoHOC }
export default WidgetPage(SimpleCtaApp)
